import { useMemo } from 'react';

import { useCropCatalogue } from 'hooks/useCropCatalogue';
import { useMOrgId } from 'hooks/useMOrgId';
import { MergedCrop } from 'interfaces/IGlobalCatalogue';

import { StepSelectorOption } from './stepConfig';

const toStepSelectorOption = (crop: MergedCrop): StepSelectorOption => ({
  label: crop.name,
  item: crop.name,
  globalId: crop.globalId,
  varieties: crop.varieties,
  rate: crop.rate ?? null,
  cost: crop.cost ?? null,
  unit: crop.rateUnit ?? null,
});

export const useSeedCatalogue = (
  gOrgId: string | null,
  selectedId: string | null = null
) => {
  const mOrgId = useMOrgId();

  const {
    items,
    isLoading,
    isSearchFetching,
    isPaginating: isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    hasFetchNextPageError,
    searchTerm,
    onSearch,
    clearSearch,
  } = useCropCatalogue(gOrgId, mOrgId, selectedId);

  const seedOptions = useMemo(() => items.map(toStepSelectorOption), [items]);

  return {
    seedOptions,
    isLoading,
    isSearchFetching,
    hasNextPage: !!hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    hasFetchNextPageError,
    searchTerm,
    onSearch,
    clearSearch,
  };
};
